import axios from 'axios';
import api_url from './api_url';

export default class MoodleService {
  constructor(base_url) {
    this.base_url = base_url || api_url;
  }

  async getUsers(token, key, value) {
    const params = new URLSearchParams({ key, value });
    const response = await axios.get(`${this.base_url}/v1/moodle/users?${params.toString()}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return response.data;
  }

  async getUsersByField(token, field, value) {
    const params = new URLSearchParams({ field, value });
    const response = await axios.get(
      `${this.base_url}/v1/moodle/users/by-field?${params.toString()}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    return response.data;
  }

  async getCategories(token, key, value) {
    const query = {};
    if (key) {
      query.key = key;
      query.value = value;
    }
    const params = new URLSearchParams(query);
    const suffix = params.toString() ? `?${params.toString()}` : '';
    const response = await axios.get(`${this.base_url}/v1/moodle/categories${suffix}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return response.data;
  }

  async getCourses(token, field, value) {
    const query = {};
    if (field) {
      query.field = field;
      query.value = value;
    }
    const params = new URLSearchParams(query);
    const suffix = params.toString() ? `?${params.toString()}` : '';
    const response = await axios.get(`${this.base_url}/v1/moodle/courses${suffix}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return response.data;
  }

  async createUsers(token, users) {
    const response = await axios.post(
      `${this.base_url}/v1/moodle/users`,
      { users },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );

    return response.data;
  }

  async enrolUser(token, userid, courseids) {
    const response = await axios.post(
      `${this.base_url}/v1/moodle/enrol`,
      { userid, courseids },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );

    return response.data;
  }
}
